'use client';

import { clientFetchDedupe } from '@/lib/client-fetch-dedupe';
import type {
  CookieConsentResponse,
  CookieServiceAttributes,
  CookieServiceResponse,
} from '@/types/cookie-consent';

function mapServiceRows(rows: unknown[]): CookieServiceAttributes[] {
  return rows
    .map((item) => {
      const row = item as { attributes?: CookieServiceAttributes };
      const attrs = { ...(row.attributes ?? (item as CookieServiceAttributes)) };
      if (attrs.script) {
        if (attrs.script.position === 'head') {
          attrs.script_head = attrs.script.content;
          attrs.script_body = null;
        } else if (attrs.script.position === 'body') {
          attrs.script_head = null;
          attrs.script_body = attrs.script.content;
        }
      }
      return attrs;
    })
    .filter((s) => s.is_active);
}

/** Tek uçuşta consent + services (client bootstrap). */
export async function fetchCookieConsentBootstrap(language?: string): Promise<{
  consent: CookieConsentResponse | null;
  services: CookieServiceAttributes[];
}> {
  const langQ = language ? `?language=${encodeURIComponent(language)}` : '';
  const cacheKey = `cookie-bootstrap:${language ?? 'default'}`;

  return clientFetchDedupe(cacheKey, async () => {
    const [consentRes, servicesRes] = await Promise.all([
      fetch(`/api/cookie-consent${langQ}`, { cache: 'no-store' }),
      fetch(`/api/cookie-services${langQ}`, { cache: 'no-store' }),
    ]);

    let consent: CookieConsentResponse | null = null;
    if (consentRes.ok) {
      try {
        consent = (await consentRes.json()) as CookieConsentResponse;
      } catch {
        consent = null;
      }
    }

    let services: CookieServiceAttributes[] = [];
    if (servicesRes.ok) {
      try {
        const data = (await servicesRes.json()) as CookieServiceResponse & { data?: unknown[] };
        const rows = Array.isArray(data.data) ? data.data : [];
        services = mapServiceRows(rows);
      } catch {
        services = [];
      }
    }

    return { consent, services };
  });
}
